// extracted by mini-css-extract-plugin
export default {"root":"_1gJUF","text-block":"o9YsH","textBlock":"o9YsH","prefix":"_1ZK5s"};